import '../stylesheets/ui.css';
import './dev.js';

const onFormFieldFocus = (event) => {
  const container = event.target.closest(".form__field");
  container.classList.add("form__field--active");
};

const onFormFieldBlur = (event) => {
  const field = event.target;
  const container = field.closest(".form__field");
  const filled = field.value.length > 0;

  container.classList.toggle("form__field--active", filled);
};

const disableSubmitBtns = () => {
  document.querySelectorAll('[type="submit"]').forEach(btn => btn.disabled = true);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(".form__field--js>input").forEach(field => {
    field.addEventListener("focus", onFormFieldFocus);
    field.addEventListener("blur", onFormFieldBlur);
  });
  document.querySelectorAll('form').forEach(form => {
    if (!form.dataset.noAutoDisable) {
      form.addEventListener('submit', disableSubmitBtns);
    }
  });
  document.querySelectorAll('.debug').forEach(dbg => {
    dbg.addEventListener('click', event => {
      if (event.target.classList.contains('debug')) {
        dbg.classList.toggle('debug--collapsed');
      }
    });
  });
});
